import React, {PropTypes} from 'react';

export default function CharacterDetailList({title, items, ordered}) {

  const listItems = items.map(item => <li key={item.id}>{item.text}</li>);

  return (
    <div className="character-detail-list">
      <div className="title">{title}</div>
      <div className="list">
        {
          ordered
            ? <ol>{listItems}</ol>
           : <ul>{listItems}</ul>

        }
      </div>
    </div>
  );
}

CharacterDetailList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  ordered: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/characterDetail/components/CharacterDetailList.js